export const URL_BEYOND = 'https://www.ovoenergy.com/beyond';
export const URL_CONTENT_IN_APP = 'https://beyond.ovoenergy.com/content-in-app';
